<template>
  <div class="card-container tw-flex tw-items-center">
    <div class="information-container tw-flex">
      <img v-if="data['imgSrc']" class="image-info" :src="data['imgSrc']" />
      <div
        data-cy="card-role-setting-role-name"
        class="information tw-flex tw-flex-none tw-flex-col tw-mr-12 tw-leading-[normal]"
      >
        <span class="name tw-font-[500]">{{
          `${data.firstName} ${data.lastName}`
        }}</span>
        <span class="email tw-text-[12px] grey-color">{{ data.email }}</span>
      </div>
    </div>
    <div class="company tw-text-[13px]">
      {{ data.homeOrgNameShort }}
    </div>
  </div>
</template>

<script lang="ts">
import { Component, Prop, Vue } from "vue-facing-decorator";
import ButtonShowMore from "@/components/common/setting/buttonShowMore.vue";
import CustomDropDownItem from "@/components/common/customDropDownItem.vue";
import { IOrgMember } from "@/interfaces/org/role";

export interface ICardRolesSetting {
  imgSrc?: string;
  name: string;
  email: string;
  company: string;
}

@Component({ components: { ButtonShowMore, CustomDropDownItem } })
export default class CardRolesSetting extends Vue {
  @Prop({ required: true }) readonly data: IOrgMember = {} as IOrgMember;
}
</script>

<style scoped>
.card-container {
  min-width: 100%;
  width: fit-content;
  padding: 18px 25px;
  background-color: #ffffff;
  border: 1px solid #eff0f1;
  border-bottom: none;
}

.card-container:first-child {
  border-top-left-radius: 6px;
  border-top-right-radius: 6px;
}

.card-container:last-child {
  border-bottom-left-radius: 6px;
  border-bottom-right-radius: 6px;
  border-bottom: 1px solid #eff0f1;
}

.grey-color {
  color: #878787;
}

.card-container .information-container {
  min-width: 235px;
}

.card-container .information .name {
  font-size: 13px;
}

.card-container .image-info {
  width: 32px;
  height: 32px;
  border-radius: 50%;
  border: 1px solid #eff0f1;
  margin-right: 15px;
}

.company {
  font-family: "Poppins";
}

.role-container .role {
  height: 34px;
  border: 1px solid #eff0f1;
  border-radius: 100px;
  font-size: 11px;
  line-height: 14.3px;
  background-color: #ffffff;
}

.role-container .role img {
  width: 10px;
  height: 10px;
}
</style>
